import { useTranslations } from 'next-intl';
import './chatbot-message-active-tool-call.css';
import { ChatbotMessage } from './types';

interface ChatbotMessageActiveToolCallProps {
  message: ChatbotMessage;
}

interface ToolMention {
  target: string;
}

export function ChatbotMessageActiveToolCall({ message }: ChatbotMessageActiveToolCallProps) {
  const t = useTranslations();
  let tKey = 'features.ai-helper.tool_call_' + message?.activeToolCall?.name;
  tKey = t.has(tKey) ? tKey : 'features.ai-helper.tool_call_default';

  const parameters = message?.activeToolCall?.parameters;
  if (parameters?.mentions) {
    const mentions = parameters.mentions as ToolMention[];
    if (mentions.length === 1 && mentions[0].target === 'note') {
      if (t.has(tKey + '_one_note')) {
        tKey += '_one_note';
      }
    }
  }

  return (
    <div className="chatbot-message-active-tool-call-masked-text">
      <span>{t(tKey)}</span>
      <div className="chatbot-message-active-tool-call-loading-dots"></div>
    </div>
  );
}
